"use client";

import { useSession } from "next-auth/react";
import { HTMLProps } from "~/app/components/html.types";
import { anonymousImageUrl } from "./resources";

export function SessionAvatarUseClient({
  size = 6,
  className,
  ...props
}: HTMLProps<{ size?: number }, HTMLImageElement>) {
  const session = useSession();
  const px = size * 4;
  const imageUrl = session?.data?.user?.image?.replace("s96", `s${4 * px}`);

  return (
    <img
      src={session.status !== "authenticated" ? anonymousImageUrl : imageUrl}
      width={px}
      height={px}
      className={`text-indigo-400 h-${size} w-${size} max-h-${size} max-w-${size} flex-none rounded-full bg-gray-50 ${className}`}
      alt=""
      {...props}
    />
  );
}
